import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=403cc64e&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=ts"
export * from "./ClientsTable.vue?vue&type=script&lang=ts"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=403cc64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403cc64e",
  null
  
)

export default component.exports